export function initDate () {
    return {
        slidCarousels: document.querySelectorAll('.dws_slid_carousel'),
    }
}